import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig";
import { MsalProvider } from "@azure/msal-react";
import Login from "./Login";
import { useEffect } from "react";

// Initialize MSAL instance ONCE (outside the component)
const msalInstance = new PublicClientApplication(msalConfig);

const User = () => {
  useEffect(() => {
    console.log("Inside User useeffect msalInstance ", msalInstance)
    // Set active account on initial load
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    // Event callback for updating active account
    const callbackId = msalInstance.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Login />
    </MsalProvider>
  );
};

export default User;
